import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "./Signup.css";

const Signup = () => {
  const { sendOTP, verifyOTP, signup } = useAuth();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");
  const [rePassword, setRePassword] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);

  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(0);
  const [canResend, setCanResend] = useState(true);

  useEffect(() => {
    let interval;

    if (timer > 0) {
      interval = setInterval(() => setTimer((prev) => prev - 1), 1000);
    } else {
      setCanResend(true);
    }

    return () => clearInterval(interval);
  }, [timer]);

  const handleSendOTP = async () => {
    if (mobile.length !== 10) return alert("Enter valid 10-digit mobile");

    try {
      setLoading(true);
      await sendOTP(mobile);
      setOtpSent(true);
      setTimer(120);
      setCanResend(false);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyOTP = async () => {
    try {
      setLoading(true);
      await verifyOTP(mobile, otp);
      setOtpVerified(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!otpVerified) return alert("Please verify OTP first");
    if (password !== rePassword) return alert("Passwords do not match");

    try {
      setLoading(true);
      await signup({ name, email, mobile, password });
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signup-page-bg">
      <div className="signup-card">

        <h2 className="signup-title">Cashify</h2>
        <p className="signup-subtitle">Create your account</p>

        <form onSubmit={handleSubmit}>

          {/* NAME */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Name</label>
            <input
              className="form-control signup-input"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />
          </div>

          {/* EMAIL */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Email (optional)</label>
            <input
              type="email"
              className="form-control signup-input"
              placeholder="Enter email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>

          {/* MOBILE */}
          <div className="mb-3">
            <label className="form-label fw-semibold">Mobile Number</label>
            <input
              type="tel"
              className="form-control signup-input"
              placeholder="Enter 10-digit mobile"
              maxLength="10"
              value={mobile}
              onChange={(e) => setMobile(e.target.value)}
              required
              disabled={otpSent}
            />
          </div>

          {/* SEND OTP */}
          {!otpSent && (
            <button
              type="button"
              className="btn signup-btn w-100"
              onClick={handleSendOTP}
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          )}

          {/* OTP AREA */}
          {otpSent && !otpVerified && (
            <>
              <div className="mb-3 mt-3">
                <label className="form-label fw-semibold">Enter OTP</label>
                <input
                  className="form-control signup-input"
                  placeholder="Enter 6-digit OTP"
                  maxLength="6"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </div>

              <button
                type="button"
                className="btn signup-btn w-100"
                onClick={handleVerifyOTP}
              >
                {loading ? "Verifying..." : "Verify OTP"}
              </button>

              <div className="text-center mt-2">
                {canResend ? (
                  <button className="resend-btn" onClick={handleSendOTP}>
                    Resend OTP
                  </button>
                ) : (
                  <p className="timer-text">
                    Resend in {Math.floor(timer / 60)}:
                    {(timer % 60).toString().padStart(2, "0")}
                  </p>
                )}
              </div>
            </>
          )}

          {/* PASSWORD FIELDS */}
          {otpVerified && (
            <>
              <div className="mb-3 mt-3">
                <label className="form-label fw-semibold">Password</label>
                <input
                  type="password"
                  className="form-control signup-input"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Re-enter Password
                </label>
                <input
                  type="password"
                  className="form-control signup-input"
                  placeholder="Re-enter password"
                  value={rePassword}
                  onChange={(e) => setRePassword(e.target.value)}
                  required
                />
              </div>

              <button type="submit" className="btn signup-btn w-100">
                {loading ? "Creating..." : "Create Account"}
              </button>
            </>
          )}
        </form>

        <p className="signup-bottom">
          Already have an account? <Link to="/login">Login</Link>
        </p>
      </div>
    </div>
  );
};

export default Signup;
